<template>
<div class="panelNagusia">
  <div class="ui breadcrumb">
    <a class="section" v-on:click="goTo('/dashboard')">Home</a>
    <i class="right angle icon divider"></i>
    <a v-if="!localId" class="section" v-on:click="goTo('/users')">Usuarios</a>
    <a v-if="localId" class="section" v-on:click="goTo('/local/'+localId+'/users')">Usuarios</a>
    <i class="right angle icon divider"></i>
    <a class="active section">Editar Usuario</a>
  </div>
  <h1 class="ui header"><i class="icon user"></i>
    <div class="content">Editar Usuario</div>
  </h1>
  <button v-if="!localId" class="ui basic button rightButton" v-on:click="goTo('/users')">
    <i class="long arrow alternate left icon"></i>Atras
  </button>
  <button v-if="localId" class="ui basic button rightButton" v-on:click="goTo('/local/'+localId+'/users')">
    <i class="long arrow alternate left icon"></i>Atras
  </button>
  <div v-if="!selectedUser" class="ui active centered inline loader"></div>
  <div v-if="selectedUser" class="ui stackable two column divided grid container">
    <div class="row">
      <div class="column">
        <form class="ui form" @submit.prevent="editUser">
          <h4 class="ui dividing header">Información del usuario</h4>
          <div class="inline field">
            <sui-checkbox label="Activo" toggle v-model="selectedUser.active" />
          </div>
          <div class="inline field">
            <sui-checkbox label="Acceso al admin" toggle v-model="selectedUser.login_admin" />
          </div>
          <div class="inline field">
            <sui-checkbox label="Virtual Sesión" toggle v-model="selectedUser.virtual_session" />
          </div>
          <div class="field">
            <label>Nombre y Apellido *</label>
            <input type="text" v-model="selectedUser.name" placeholder="Nombre y Apellido" required>
          </div>
          <div class="two fields">
            <div class="field">
              <label>Username *</label>
              <input type="text" v-model="selectedUser.username" placeholder="Username" required>
            </div>
            <div class="field">
              <label>Password *</label>
              <input type="password" v-model="selectedUser.password" placeholder="Password" required>
            </div>
          </div>
          <div class="field">
            <label>Email *</label>
            <input type="text" v-model="selectedUser.email" placeholder="Email" required pattern="^[a-zA-Z0-9._-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$">
          </div>          
          <div class="field">
            <label>Imagen para el Avatar</label>
            <input type="file" accept="image/*" @change="onFilePicked">
          </div>
          <div class="two fields">
            <div class="field">
              <label>Compañía *</label>
              <sui-dropdown placeholder="Compañía" search selection :options="companyOptions" v-model="selectedUser.company_id" required />
            </div>
            <div class="field">
              <label>Rol *</label>
              <sui-dropdown placeholder="Rol" search selection :options="roleOptions" v-model="selectedUser.role" required />
            </div>
          </div>
          <div class="field">
            <label>Selecciona las Taquillas *</label>
            <sui-dropdown id="taquillas" search fluid multiple :options="apmOptions" placeholder="Taquillas" selection v-model="selectedApms" />
          </div>
          <div class="two fields">
            <div class="field">
              <label>Creado</label>
              <input type="text" v-model="selectedUser.created" readonly>
            </div>
            <div class="field">
              <label>Modificado</label>
              <input type="text" v-model="selectedUser.modified" readonly>
            </div>
          </div>
          <div class="field">
            <label>* Campos obligatorios</label>
          </div>
          <button id="save" class="ui button fluid" type="submit">Guardar</button>
          <!-- <div class="ui red button eskubian" v-on:click="deleteUser()">Eliminar</div> -->
        </form>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import { hapiickApi } from '@/api/hapiickApi';
export default {
  name: 'editUser',
  props: ['id','localId'],
  data() {
    return {
      selectedUser: null,
      selectedApms: null,
      show: false,
      roleOptions: [],
      companyOptions: [],
      apmOptions: [],
      selectedRole: null
    }
  },
  created() {
    let role = JSON.parse(localStorage.admin).role
    if (role === 'master' || role === 'admin') {
      this.getRoles()
      this.getUser()
      this.getCompanies()
      let _this = this
      setTimeout(function() {
        _this.fillCompanyOptions()
      }, 2000)
    } else {
      this.$router.replace('/parcels_v2')
    }
  },
  watch: {
    'selectedUser.company_id': function(new_company, old_company) {
      if (old_company) { //Solo se vaciaran los combos del rol y taquillas cuando cambiemos la compañia
        this.selectedApms = null;
        this.selectedUser.role = null;
        this.apmOptions = [];
      }
      this.getApms(new_company);
    },
    'selectedUser.role': function(new_role, old_role) {
      if (old_role !== undefined) {
        if(new_role === 'apiclientAdmin' || new_role === 'staffappmediamarktAdmin' || new_role === 'master' || new_role === 'admin' || new_role === 'sabico') {
          this.selectedRole = new_role
          this.selectedApms = this.apmOptions.map((a) => a['key']);
        } else {
          //Vaciamos la seleccion de apts del combo
          this.selectedApms = null;
        }
      }
    }
  },
  methods: {
    getRoles() {
      this.axios.get("static/roles.json")
      .then(response => {
        const roles = response.data.roles.actives;
        const roleOptions = roles.map((role) => ({text: role, value: role}))
        this.roleOptions = roleOptions.sort((a, b) => {
          if ( a.text < b.text ){
            return -1;
          }
          if ( a.text > b.text ){
            return 1;
          }
          return 0;})
        
      })
      .catch((request) => console.log('error getting roles: ' . request));
    },
    getUser() {
      hapiickApi().post('/v2/users/get-user', {
        admin_id: JSON.parse(localStorage.admin).id,
        user_id: this.id,
        localId: this.localId
      })
      .then(request => {
        this.updateEditUser(request)
      })
      .catch(() => console.log('error getting user'))
    },
    getApms(companyId) {
      hapiickApi().post('/v1/apms/companies', {
        admin_id: JSON.parse(localStorage.admin).id,
        companyId: companyId
      })
      .then(request => {
        this.apms = JSON.parse(JSON.stringify(request.data.data.apms))
        this.fillApmOptions();
      })
      .catch(() => console.log('error getting apms'))
    },
    getCompanies() {
      hapiickApi().post('/v2/companies', {
          admin_id: JSON.parse(localStorage.admin).id
        })
        .then(request => this.companies = JSON.parse(JSON.stringify(request.data.data.companies)))
        .catch((request) => console.log('error getting companies: ' + request));
    },
    editUser() {
      const rolNotUse = ['shophapiickPoint'];
      if (rolNotUse.includes(this.selectedUser.role)) {
        this.$swal.fire({
          type: 'info',
          title: 'No se puede modificar un usuario con este rol',
          text: 'Para modificarlo hay que ir a su mantenimiento correspondiente'
        })
        return
      }

      let x = document.getElementById("save");
      x.classList.add("loading");
      x.disabled = true;

      hapiickApi().post('/v3/users/edit', {
          admin_id: JSON.parse(localStorage.admin).id,
          userData: this.selectedUser,
          localId: this.localId,
          localUserId: this.id,
          apmsData: this.selectedApms,
        })
        .then(request => {
          this.userSaved(request)
        })
        .catch(() => this.$swal({
          type: 'error',
          title: 'Error',
          text: 'No se han podido guardar los datos'
        }))
    },
    goTo(where) {
      this.$router.push(where)
    },
    updateEditUser(req) {
      let user = JSON.parse(JSON.stringify(req.data.data.user))
      let apms = JSON.parse(JSON.stringify(req.data.data.apts))
      this.selectedUser = user.Administrator
      this.selectedApms = apms
    },
    fillCompanyOptions() {
      for (let i = 0; i < this.companies.length; i++) {
        this.companyOptions.push({
          text: this.companies[i].AdminCompany.name,
          value: this.companies[i].AdminCompany.id
        })
      }
    },
    fillApmOptions() {
      for (let i = 0; i < this.apms.length; i++) {
        this.apmOptions.push({
          key: this.apms[i].Apt.id,
          text: this.apms[i].Apt.LanguagesApts[0].name,
          value: this.apms[i].Apt.id
        })
      }
    },
    onFilePicked(event) {
      const files = event.target.files
      let filename = files[0].name
      if (filename.lastIndexOf('.') <= 0) {
        return alert('Please add a valid file!')
      }
      const fileReader = new FileReader()
      fileReader.addEventListener('load', () => {
        this.selectedUser.image = fileReader.result
      })
      fileReader.readAsDataURL(files[0])
    },
    userSaved(req) {
      let x = document.getElementById("save");
      x.classList.remove("loading");
      x.disabled = false;
      let msg='';
      if (req.data.status !== 'OK') {
        if (req.data.status === 'KO') {
          msg = req.data.message;
        } else {
          msg = 'No se han podido guardar los datos';
        }
        this.$swal({
          type: 'error',
          title: 'Error',
          text: msg
        })
      } else {
         this.$swal({
          type: 'success',
          title: 'Los datos se han guardado correctamente',
          showConfirmButton: false,
          timer: 2500
        })
        this.selectedUser = null
        if(!this.localId) {
          this.goTo('/users')
        } else {
          this.goTo('/local/'+this.localId+'/users', 'localUsers')
        } 
      }
    }
  }
}
</script>
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Users/editUser.vue